import stickySummary from '../components/plan-summary/sticky'
import store from 'utils/store/withMiddleware'

function deleteLatitude(e) {
  const state = store.getState()
  const addOns = state.addOns.filter(id => id !== state.latitudeId)
  store.update({ addOns, latitudeId: undefined })
  e.stopPropagation()
  e.preventDefault()
  stickySummary()
}

export default deleteLatitude
